import { useMutation } from "@apollo/client";

import { GqlWorkerVisitReportStatus } from "~/__generated__";

import { ProjectReviewVisitV2TeamReportsRoute_UpdateReportsStatusDocument } from "../mutations.generated";

export function useProjectReviewVisitV2TeamReportsRoute_UpdateReportsStatus() {
    const [mutate, { loading, error }] = useMutation(ProjectReviewVisitV2TeamReportsRoute_UpdateReportsStatusDocument);

    const updateReportsStatus = async (plannerVisitId: string, status: GqlWorkerVisitReportStatus) => {
        await mutate({ variables: { input: { plannerVisitId, status } } });
    };

    return {
        updateReportsStatus,
        loading,
        error,
    };
}
